<template>
  <InputWrapper
    :id="props.id"
    :label="props.label"
    :helperText="props.helperText"
    :required="props.required"
    :error="props.error"
    :subLabel="props.placeholder"
    :for="props.id"
  >
    <div
      class="btn-group"
      role="group"
    >
      <template
        v-for="option in props.options"
        :key="option.value"
      >
        <input
          type="radio"
          class="btn-check"
          autocomplete="off"
          :id="`${option.value}-${props.id}-radio`"
          :checked="option.value === modelValue"
          :disabled="props.disabled"
          @change="onChange(option.value)"
        />
        <label
          :class="`radio-btn-input-${
            option.variant || RadioButtonOptionVariant.PRIMARY
          }`"
          :for="`${option.value}-${props.id}-radio`"
        >
          <span>{{ option.label }}</span>
          <Pill
            v-if="option.count"
            size="sm"
            :variant="
              option.variant === RadioButtonOptionVariant.EXCEPTION
                ? PillVariant.EXCEPTION
                : PillVariant.INFO_PRIMARY
            "
          >
            <span class="count">{{ option.count }}</span>
          </Pill>
        </label>
      </template>
    </div>
  </InputWrapper>
</template>
<script lang="ts">
export enum RadioButtonOptionVariant {
  PRIMARY = 'primary',
  EXCEPTION = 'exception'
}
</script>
<script setup lang="ts">
import InputWrapper from '@component-module/components/InputWrapper/InputWrapper.vue';
import Pill, { PillVariant } from '@component-module/components/Pill/Pill.vue';

const emit = defineEmits(['update:modelValue']);

const props = defineProps<{
  id: string;
  options: {
    label: string;
    value: string;
    variant?: RadioButtonOptionVariant;
    count?: number;
  }[];
  modelValue: string | boolean | null;
  label?: string;
  helperText?: string;
  required?: boolean;
  error?: string;
  disabled?: boolean;
  placeholder?: string;
}>();

const onChange = (val: string | boolean) => {
  emit('update:modelValue', val);
};
</script>
<style lang="scss" scoped>
.btn-group {
  display: flex;
  width: 100%;
}

[class|='radio-btn-input'] {
  display: flex;
  flex: 1 0 0;
  min-width: max-content;
  gap: $spacing-xs;
  align-items: center;
  justify-content: center;
  text-align: center;
  border: 1px solid $brand-black;
  border-left: none;
  padding: $spacing-3xs $spacing-xs;
  font-size: $font-size-xs;
  font-weight: 400;
  cursor: pointer;
  &:first-of-type {
    border-radius: $border-radius-md 0 0 $border-radius-md;
    border-left: 1px solid;
  }
  &:last-of-type {
    border-radius: 0 $border-radius-md $border-radius-md 0;
  }
}

.radio-btn-input-primary {
  border-color: $brand-blue;
  color: $brand-blue;
}

.radio-btn-input-exception {
  border-color: $red-44;
  color: $red-44;
}

.btn-check {
  &:checked {
    + .radio-btn-input-primary {
      background-color: $brand-blue;
      color: $white;
    }
    + .radio-btn-input-exception {
      background-color: $red-44;
      color: $white;
    }
  }
}
.count {
  line-height: $font-size-xs;
  padding: 0 $spacing-4xs;
}
</style>
